import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import { baseURL } from '../config';
import { setAccessToken, tokenController } from './tokenController';

type RetryConfig = InternalAxiosRequestConfig & { _authRetry?: boolean };
let refreshPromise: Promise<string | null> | null = null;

axios.defaults.withCredentials = true;

export const refreshAccessToken = async (): Promise<string | null> => {
    if (!refreshPromise) {
        refreshPromise = axios
            .post(`${baseURL}api/auth/refresh`, undefined, { withCredentials: true })
            .then((response) => {
                const token = response.data?.accessToken || response.data?.token || null;
                setAccessToken(token);
                return token;
            })
            .catch(() => {
                setAccessToken(null);
                return null;
            })
            .finally(() => {
                refreshPromise = null;
            });
    }
    return refreshPromise;
};

axios.interceptors.request.use((config) => {
    const token = tokenController();
    if (token && !config.headers.Authorization) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

axios.interceptors.response.use(
    (response) => response,
    async (error: AxiosError) => {
        const config = error.config as RetryConfig | undefined;
        const isAuthEndpoint = Boolean(config?.url?.includes('/auth/login') || config?.url?.includes('/auth/refresh'));
        if (error.response?.status !== 401 || !config || config._authRetry || isAuthEndpoint) {
            return Promise.reject(error);
        }
        config._authRetry = true;
        const token = await refreshAccessToken();
        if (!token) return Promise.reject(error);
        config.headers.Authorization = `Bearer ${token}`;
        return axios(config);
    }
);
